const dateUnitList = ['MONTH', 'YEAR', 'DAY'];

export default dateUnitList;
